import { Stack } from '@talos/kyoko';
import styled from 'styled-components';

export const MarketSelectorWrapper = styled(Stack)``;
MarketSelectorWrapper.defaultProps = {
  w: '100%',
  h: '100%',
  justifyContent: 'flex-start',
  gap: 'spacing8',
  overflow: 'hidden',
  position: 'relative',
};
